import FinishType from "@/model/flow/FinishType"
import { sessionService, workflowService } from "@/service"
import FinishFlowAction from "@/action/actions/FinishFlowAction"
import debounce from "lodash/debounce"

export default {
    data() {
        return {
            autoFinishMillis: 300000,
            finishType: FinishType.COMPLETED,
        }
    },

    mounted() {
        sessionService.setMinTimeoutMillis(this.autoFinishMillis + sessionService.warnCountdownMillis + 10000)
        this.$el.addEventListener("click", this.__resetTimeout)
        this.$el.addEventListener("keydown", this.__resetTimeout)
        this.__startTimeout()
    },

    beforeDestroy() {
        clearTimeout(this.__autoFinishTimeout)
        this.$el.removeEventListener("keydown", this.__resetTimeout)
        this.$el.removeEventListener("click", this.__resetTimeout)
    },

    methods: {
        __startTimeout() {
            this.__autoFinishTimeout = setTimeout(this.finish, this.autoFinishMillis)
        },

        __resetTimeout: debounce(function() {
            clearTimeout(this.__autoFinishTimeout)
        }, 500),

        async finish() {
            clearTimeout(this.__autoFinishTimeout)
            await workflowService.invoke(new FinishFlowAction(this.finishType))
        },
    },
}
